'use client';

import { c as _c } from "react/compiler-runtime";
import { useIntentPrefetch } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { cn } from '@/lib/ui/utils';
export type PnlHeroRange = '1h' | '1d' | '1w' | '1m' | 'all';
export interface PnlHeroWindow {
  readonly range: PnlHeroRange;
}
const RANGES: readonly PnlHeroRange[] = ['1h', '1d', '1w', '1m', 'all'];
export function PnlHeroTimeframes(t0) {
  const $ = _c(10);
  const {
    window,
    onChange,
    onPrefetch
  } = t0;
  const t = useTranslations("profile.stats");
  const tRange = useTranslations("competitions.list");
  let t1;
  if ($[0] !== t) {
    t1 = t("pnl_chart_range_label");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onChange || $[3] !== onPrefetch || $[4] !== tRange || $[5] !== window) {
    t2 = RANGES.map(range => <TimeframeButton key={range} range={range} label={range === "all" ? tRange("all") : range.toUpperCase()} selected={range === window.range} onChange={onChange} onPrefetch={onPrefetch} />);
    $[2] = onChange;
    $[3] = onPrefetch;
    $[4] = tRange;
    $[5] = window;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <fieldset className="m-0 flex w-full min-w-0 items-center gap-2 border-0 p-0" aria-label={t1}>{t2}</fieldset>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function TimeframeButton(t0) {
  const $ = _c(16);
  const {
    range,
    label,
    selected,
    onChange,
    onPrefetch
  } = t0;
  let t1;
  if ($[0] !== onPrefetch || $[1] !== range || $[2] !== selected) {
    t1 = () => {
      if (!selected) {
        onPrefetch({
          range
        });
      }
    };
    $[0] = onPrefetch;
    $[1] = range;
    $[2] = selected;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const intent = useIntentPrefetch(t1);
  const t2 = selected ? "bg-background-tertiary font-medium text-foreground-primary" : "text-foreground-tertiary";
  let t3;
  if ($[4] !== t2) {
    t3 = cn("min-w-0 flex-1 hover:bg-background-tertiary/50 hover:text-foreground-primary", t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onChange || $[7] !== range || $[8] !== selected) {
    t4 = () => {
      if (!selected) {
        onChange({
          range
        });
      }
    };
    $[6] = onChange;
    $[7] = range;
    $[8] = selected;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== intent || $[11] !== label || $[12] !== selected || $[13] !== t3 || $[14] !== t4) {
    t5 = <AnimatedButton variant="tertiary" size="sm" className={t3} aria-pressed={selected} {...intent} onClick={t4}>{label}</AnimatedButton>;
    $[10] = intent;
    $[11] = label;
    $[12] = selected;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}